import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import axios from "axios";
import { API_BASE_URL } from './config';
import "./style.css";

const CastingInfo = () => {
  const [isEdited, setIsEdited] = useState(false);
  const handleButtonEdit = () => {
    setIsEdited(!isEdited);
  };

  const handleUpload = (event, key) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewImage((prev) => ({
          ...prev,
          [key]: { image: reader.result },
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const [machineData, setMachineData] = useState([]);
  const [machineDetails, setMachineDetails] = useState(null);

  const [editModel, setEditModel] = useState("");
  useEffect(() => {
    if (machineDetails) {
      setEditModel(machineDetails[0]?.機台型號 || "");
    }
  }, [machineDetails]);

  const [data, setData] = useState([]);
  const [NewImage, setNewImage] = useState({
    measurementPointFile: { image: "" },
    impactPositionFile: { image: "" },
    machineImageFile: { image: "" }
  });
  const measurementInputRef = useRef(null);
  const impactInputRef = useRef(null);
  const machineInputRef = useRef(null);

  const handleSave = async (id, updatedImages) => {
    console.log("Updating ID:", id);
    console.log("Updated Images:", updatedImages);

    if (!id) {
      console.error("Error: Missing ID");
      return;
    }

    if (!updatedImages) {
      console.error("Error: Missing updatedImages");
      return;
    }

    setIsEdited(false);

    // 檢查每個圖片欄位是否為空字串，如果是空字串就不更新
    const dataToSave = {};

    if (updatedImages.measurementPointFile?.image) {
      dataToSave.measurementPointFile = updatedImages.measurementPointFile;
    }

    if (updatedImages.impactPositionFile?.image) {
      dataToSave.impactPositionFile = updatedImages.impactPositionFile;
    }

    if (updatedImages.machineImageFile?.image) {
      dataToSave.machineImageFile = updatedImages.machineImageFile;
    }

    dataToSave.machineModel = editModel;

    if (Object.keys(dataToSave).length === 0) {
      console.error("Error: No valid images to update");
      return;
    }

    try {
      await axios.post(`${API_BASE_URL}/NewImageCasting`, {
        id,
        ...dataToSave
      });

      // 更新前端資料
      setData((prevData) =>
        prevData.map((machine) =>
          machine._id === id ? { ...machine, ...updatedImages } : machine
        )
      );

      // 更新前端顯示
      setMachineDetails(prev => {
        if (!prev) return prev;
        const updated = [{ ...prev[0], 機台型號: editModel }];
        return updated;
      });

      console.log(`${id} updated successfully`);
    } catch (error) {
      console.error(`Error updating ${id}:`, error);
    }
  };

  const location = useLocation();
  const TempData = location.state?.TempData || {};

  const { id: machineId } = useParams();

  const navigate = useNavigate();
  const onCastingManagement = (e) => {
    e.preventDefault();
    navigate('/casting-management');
  };

  useEffect(() => {
    const fetchMachineData = () => {
      const data = [{
        鑄件: TempData.company,
        料號: TempData.client,
        資料ID: TempData.dataId,
        機台型號: TempData.machineModel,
        機台型式: TempData.machineForm,
        測量時間: TempData.measurementTime,
      }];
      setMachineDetails(data);
      setMachineDetails(data);
    };

    if (machineId) {
      fetchMachineData();
    }
  }, [machineId]);

  if (!machineDetails) return <div>Loading...</div>;

  const { 鑄件, 料號, 資料ID, 機台型號, 機台型式, 測量時間 } = machineDetails[0];

  return (
    <div className="d-flex" style={{ width: '81.7%', margin: '0 auto' }}>
      <div className="container-fluid">
        <div style={{ height: '35px', width: '100%' }}></div>

        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#" onClick={onCastingManagement} style={{ color: '#B0B7C3', fontWeight: 'bold', fontSize: '15px' }}>鑄件資料庫</a>
            </li>
            <li className="breadcrumb-item" aria-current="page" style={{ color: '#5B82B1', fontWeight: 'bold', fontSize: '15px' }}>
              資料檢視 {機台型號}
            </li>
          </ol>
        </nav>

        <div style={{ height: '10px', width: '100%' }}></div>

        <form>
          <div className="d-flex flex-column">
            <div className="flex-row">
              <span className="sub-title">基本資料</span>
              <button
                type="button"
                className="edit-bnt bi bi-pencil"
                onClick={handleButtonEdit}
                style={{ color: isEdited ? '#E3E3E3' : '#757575' }}
              >
              </button>
            </div>

            <div style={{ height: '30px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">
              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="inputNo1" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>鑄件</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo1" defaultValue={鑄件} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo2" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>料號</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo2" defaultValue={料號} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo3" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>資料ID</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo3" defaultValue={資料ID} readOnly />
                  </div>
                </div>
              </div>

              <div className="p-1 flex-fill">
                <div className="row mb-3">
                  <label htmlFor="inputNo6" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>機台型號</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      id="inputNo6"
                      value={isEdited ? editModel : 機台型號}
                      readOnly={!isEdited}
                      onChange={e => isEdited && setEditModel(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo7" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>機台型式</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo7" defaultValue={機台型式} readOnly />
                  </div>
                </div>

                <div className="row mb-3">
                  <label htmlFor="inputNo8" className="col-sm-2 col-form-label text-sm-start text-start" style={{ minWidth: "120px" }}>測量時間</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="inputNo8" defaultValue={測量時間} readOnly />
                  </div>
                </div>
              </div>

            </div>

            <div style={{ height: '35px', width: '100%' }}></div>

            <span className="sub-title">測量記錄</span>

            <div style={{ height: '35px', width: '100%' }}></div>

            <div className="d-flex flex-column flex-md-row">

              <div className="flex-fill text-center" style={{ margin: "10px", width: "100%" }}>
                <div
                  className="card d-flex justify-content-center align-items-center flex-fill"
                  style={{
                    marginBottom: "20px",
                    padding: isEdited ? "10px" : "0px",
                    border: isEdited ? "2px dashed #B7CCDF" : "none",
                    borderRadius: "5px",
                    height: "230px",
                    width: "100%",
                    position: "relative",
                    cursor: isEdited ? "pointer" : "default"
                  }}
                  onClick={() => isEdited && measurementInputRef.current.click()}
                >
                  {isEdited && !NewImage.measurementPointFile.image ? (
                    <span style={{ color: "#999", fontSize: "14px" }}>選擇檔案</span>
                  ) : (
                    <img
                      src={NewImage.measurementPointFile.image || TempData.measurementPointFile?.image || ""}
                      className="card-img img-fluid"
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        backgroundColor: isEdited && !NewImage.measurementPointFile.image ? "#f0f0f0" : "transparent"
                      }}
                    />
                  )}
                </div>
                <label htmlFor="measurementPointUploadInput" style={{ fontSize: "15px", marginBottom: "5px" }}>
                  量測點位
                </label>
                {isEdited && <input type="file" ref={measurementInputRef} style={{ display: "none" }} onChange={(e) => handleUpload(e, "measurementPointFile")} />}
              </div>

              <div className="flex-fill text-center" style={{ margin: "10px", width: "100%" }}>
                <div
                  className="card d-flex justify-content-center align-items-center flex-fill"
                  style={{
                    marginBottom: "20px",
                    padding: isEdited ? "10px" : "0px",
                    border: isEdited ? "2px dashed #B7CCDF" : "none",
                    borderRadius: "5px",
                    height: "230px",
                    width: "100%",
                    position: "relative",
                    cursor: isEdited ? "pointer" : "default"
                  }}
                  onClick={() => isEdited && impactInputRef.current.click()}
                >
                  {isEdited && !NewImage.impactPositionFile.image ? (
                    <span style={{ color: "#999", fontSize: "14px" }}>選擇檔案</span>
                  ) : (
                    <img
                      src={NewImage.impactPositionFile.image || TempData.impactPositionFile?.image || ""}
                      className="card-img img-fluid"
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        backgroundColor: isEdited && !NewImage.impactPositionFile.image ? "#f0f0f0" : "transparent"
                      }}
                    />
                  )}
                </div>
                <label htmlFor="impactPointUploadInput" style={{ fontSize: "15px", marginBottom: "5px" }}>
                  敲擊位置
                </label>
                {isEdited && <input type="file" ref={impactInputRef} style={{ display: "none" }} onChange={(e) => handleUpload(e, "impactPositionFile")} />}
              </div>

              <div className="flex-fill text-center" style={{ margin: "10px", width: "100%" }}>
                <div
                  className="card d-flex justify-content-center align-items-center"
                  style={{
                    marginBottom: "20px",
                    padding: isEdited ? "10px" : "0px",
                    border: isEdited ? "2px dashed #B7CCDF" : "none",
                    borderRadius: "5px",
                    height: "230px",
                    width: "100%",
                    position: "relative",
                    cursor: isEdited ? "pointer" : "default"
                  }}
                  onClick={() => isEdited && machineInputRef.current.click()}
                >
                  {isEdited && !NewImage.machineImageFile.image ? (
                    <span style={{ color: "#999", fontSize: "14px" }}>選擇檔案</span>
                  ) : (
                    <img
                      src={NewImage.machineImageFile.image || TempData.machineImageFile?.image || ""}
                      className="card-img img-fluid"
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                        backgroundColor: isEdited && !NewImage.machineImageFile.image ? "#f0f0f0" : "transparent"
                      }}
                    />
                  )}
                </div>
                <label htmlFor="machineImageUploadInput" style={{ fontSize: "15px", marginBottom: "5px" }}>
                  機台型式
                </label>
                {isEdited && <input type="file" ref={machineInputRef} style={{ display: "none" }} onChange={(e) => handleUpload(e, "machineImageFile")} />}
              </div>
            </div>

            {isEdited && TempData._id && (
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                <button
                  className="btn-save"
                  onClick={() => handleSave(TempData._id, NewImage)}
                >
                  儲存
                </button>
              </div>
            )}

            <div style={{ height: '45px', width: '100%' }}></div>

          </div>
        </form>
      </div>
    </div>
  );
};

export default CastingInfo;